import { Reveal, Stagger, StaggerItem, SectionNo, Hairline, MaskReveal } from "@/components/primitives";
import BigSectionNo from "@/components/BigSectionNo";

const ENEMIES = [
  {
    name: "The shoot tax",
    body: "The cost, lead time and friction of putting a crew in a working hotel. Site access, lighting rigs, rooms held out of inventory, staff pulled from their day, every few years, at five figures.",
  },
  {
    name: "The dead library",
    body: "Thousands of commissioned images, styled and lit at real expense. Forty of them go on the website. The rest sit in a folder, doing nothing.",
  },
  {
    name: "The still frame",
    body: "Every surface where guests actually decide is built for motion, and the property arrives holding a photograph.",
  },
];

export default function Insight() {
  return (
    <section id="problem" className="relative overflow-hidden px-6 py-20 sm:px-10 md:py-28 warm-radial" data-testid="insight">
      <BigSectionNo n="01" />
      <div className="relative mx-auto max-w-[1280px]">
        <Hairline className="mb-20" />
        <Reveal>
          <SectionNo n="01" label="The problem" />
        </Reveal>

        <div className="mt-8 grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20">
          <h2
            className="display text-primaryText"
            style={{
              fontSize: "clamp(2.25rem, 5vw, 4rem)",
              lineHeight: 1.02,
              letterSpacing: "-0.015em",
              fontWeight: 300,
            }}
          >
            <MaskReveal>You have already</MaskReveal>
            <MaskReveal delay={0.1}>paid for the pictures.</MaskReveal>
          </h2>
          <div>
            <Reveal delay={0.12}>
              <p className="text-base leading-relaxed text-mutedText sm:text-lg">
                Properties commission a full shoot every few years. It takes over
                the building for days and produces thousands of images. Then
                forty go on the website and the rest sit in a folder.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-6 text-base leading-relaxed text-mutedText sm:text-lg">
                Meanwhile, every surface where guests decide is built for motion.
                The usual answer is another five-figure crew production. The
                material is already in the folder.
              </p>
            </Reveal>
          </div>
        </div>

        <Stagger className="mt-20 grid gap-6 md:grid-cols-3">
          {ENEMIES.map((e, i) => (
            <StaggerItem key={e.name}>
              <div
                className="group h-full rounded-[3px] border border-hairline bg-surface/40 p-8 transition-colors duration-500 hover:border-gold/40"
                data-testid={`enemy-${i}`}
              >
                <span className="font-mono text-[11px] tracking-widest text-gold">
                  0{i + 1}
                </span>
                <h3 className="display mt-4 text-2xl text-primaryText transition-colors duration-500 group-hover:text-gold">
                  {e.name}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-mutedText">{e.body}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
